<template>
	<div class="container ">
			<div class="row vertical-10p">
				<div class="container card-login-center">
					<div class="row">
						<div class="col-sm-12 col-md-10 col-md-offset-1">
								<form method="#" action="#">
										<div class="card card-login">
											<img src="/network/static/img/logo.jpg" class="center-block logo">
												<div class="card-header text-center">
														<h4 class="card-title">Семейна образователна мрежа</h4>
														<!-- img src="/network/static/img/sun.png" alt="FEN" title="FEN" style="width:20px !important" -->
												</div>
												<div class="card-block	text-center">

													<!-- errors -->
													<div v-if="response" class="text-red"><p>{{response}}</p></div>

														<div class="social-line">

															<button type="button" class="loginBtn loginBtn--google" @click="login('google')">
																Влезте с Google акаунт
															</button>
														</div>
												</div>
										</div>
								</form>
						</div>
					</div>
			</div>
	</div>
</div>
</template>

<script>
var Vue = require('vue');

module.exports = {
	name: 'Login',
	data: function (router) {
		return {
			section: 'Login',
			response: ''
		};
	},
	methods: {
		login: function (method) {
			setTimeout(() => {
				location.href = Vue.config.backend + '/auth/' + method + '?redirect=' + encodeURIComponent(this.$route.query.redirect || '/');
			});
		}
	}
};
</script>

<style>
.logo {
	padding: 3em;
}
.loginForm .input-group {
	padding-bottom: 1em;
	height: 4em;
}
.input-group input {
	height: 4em;
}

.card-login-center {
	margin: auto;
	position: absolute;
	top: 0; left: 0; bottom: 0; right: 0;
	width: 50%;
	height: 50%;
	min-width: 200px;
	max-width: 400px;
	padding: 40px;
}
</style>



// WEBPACK FOOTER //
// Login.vue?a17a0aa4